import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { ConsoleShell } from '@/features/shell/console-shell';
import { ProjectResolver } from '@/features/shell/project-resolver';

/**
 * `/$tenant/connections` — entrée « Connexions » hors projet : redirige vers
 * `/$tenant/projects/$projectId/connections` (une connexion est portée par un projet au contrat).
 */
export const Route = createFileRoute('/$tenant/connections/')({ component: ConnectionsRoute });

function ConnectionsRoute() {
  const { tenant } = Route.useParams();
  const { t } = useTranslation();
  return (
    <ConsoleShell tenantId={tenant} activeItem="connections" crumbs={[{ label: t('nav.items.connections') }]}>
      <ProjectResolver tenantId={tenant} section="connections" />
    </ConsoleShell>
  );
}
